// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-insights-main-spinner-wrapper-1EIHPS-"};